import styles from "./Memoji.module.css";

import myMemoji from "../../assets/images/me/me.svg";
import blobImage from "../../assets/images/me/blob.svg";

const Memoji = (props) => {
  return (
    <div className={styles["image-box"]}>
      <img src={blobImage} alt="blob" className={styles["blob"]} />
      <img src={myMemoji} alt="My memoji" className={styles["image"]} />
    </div>
  );
};

export default Memoji;
